module.exports = __webpack_public_path__ + "img/nav-arrow-right.08aa8939.svg";